module.exports = __webpack_public_path__ + "static/media/facebook.8c89ef8a.png";